__turbopack_context__.v({
  "info-icon": "Fb8MoG_info-icon",
  "input": "Fb8MoG_input",
  "input-bold": "Fb8MoG_input-bold",
  "input-center": "Fb8MoG_input-center",
  "input-left-slot": "Fb8MoG_input-left-slot",
  "input-right-slot": "Fb8MoG_input-right-slot",
  "input-row": "Fb8MoG_input-row",
  "input-row-disabled": "Fb8MoG_input-row-disabled",
  "input-row-error": "Fb8MoG_input-row-error",
  "input-row-success": "Fb8MoG_input-row-success",
  "label-wrapper": "Fb8MoG_label-wrapper",
  "slot-left": "Fb8MoG_slot-left",
  "slot-right": "Fb8MoG_slot-right",
  "sub-label": "Fb8MoG_sub-label",
  "suffix-text": "Fb8MoG_suffix-text",
  "tooltip-trigger": "Fb8MoG_tooltip-trigger",
  "wrapper": "Fb8MoG_wrapper",
});
